import { MySwal } from "../lib/swal";

const errorHandler = ({ err }) => {
  // console.log(err.errors[0])
  if (err.errors[0] === "invalid token") {
    localStorage.clear();
    MySwal.fire({
      icon: "error",
      title: "UNAUTHORIZED",
      text: "You have to login again",
    }).then(() => {
      window.location.href = "https://registration.prasmul-eli.co/login";
      // window.location.href = 'http://localhost:3000/login'
    });
  }
  if (err.code === "400" || err.code === "403") {
    let errorsHtml = ``;
    if (err?.errors && Array.isArray(err?.errors)) {
      err.errors.forEach((item) => {
        errorsHtml += `<li>${item}.</li>`;
      });
    }
    console.log(errorsHtml);
    return MySwal.fire({
      icon: "warning",
      title: err?.status || "error",
      html: `<ul>${errorsHtml}</ul>`,
    });
  } else if (err.code === "404") {
    let errorsHtml = ``;
    if (err?.errors && Array.isArray(err?.errors)) {
      err.errors.forEach((item) => {
        errorsHtml += `<li>${item}.</li>`;
      });
    }
    return MySwal.fire({
      icon: "warning",
      title: err?.status || "error",
      html: `<ul>${errorsHtml}</ul>`,
    });
  } else if (err.code === "401") {
    localStorage.clear();
    MySwal.fire({
      icon: "error",
      title: "UNAUTHORIZED",
      text: "You have to login again",
    }).then(() => {
      window.location.href = "https://registration.prasmul-eli.co/login";
      // window.location.href = 'http://localhost:3000/login'
    });
  } else {
    let errorsHtml = ``;
    if (err?.errors && Array.isArray(err?.errors)) {
      err.errors.forEach((item) => {
        errorsHtml += `<li>${item}.</li>`;
      });
    }
    return MySwal.fire({
      icon: "warning",
      title: err?.status || "error",
      html: `<ul>${errorsHtml}</ul>`,
    });
  }
};

export default errorHandler;
